import AppStateHandler from "src/StateHandlers/AppStateHandler";

export const logger = (
  endPoint: string | undefined,
  log: any,
  isError?: boolean
) => {
  if (isError) {
    console.log(endPoint, log.response);
  } else {
    console.log(endPoint, log);
  }
};

export const onError = (error: any) => {
  console.log({ error: error?.response });
  if (error?.response) {
    if (Array.isArray(error.response)) {
      const { status } = error.response[error.response.length - 1];
      if (status === 401) {
        AppStateHandler.resetState();
        AppStateHandler.setState({ loading: false });
        localStorage.clear();
      }
    } else {
      const { status } = error.response;
      if (status === 401) {
        AppStateHandler.resetState();
        AppStateHandler.setState({ loading: false });
        localStorage.clear();
      }
    }
  }
};
